import type { SVGProps } from 'react';

const Register = (props: SVGProps<SVGSVGElement>) => (
  <svg
    fill="none"
    height={211}
    viewBox="0 0 212 211"
    width={212}
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <clipPath id="a">
      <path d="m0 0h212v211h-212z" />
    </clipPath>
    <mask id="b" height={211} maskUnits="userSpaceOnUse" width={212} x={0} y={0}>
      <path d="m0 0h212v211h-212z" fill="#fff" />
    </mask>
    <g clipPath="url(#a)">
      <g mask="url(#b)">
        <path
          d="m106.5 202c53.295 0 96.5-43.205 96.5-96.5 0-53.2955-43.205-96.5-96.5-96.5-53.2955 0-96.5 43.2045-96.5 96.5 0 53.295 43.2045 96.5 96.5 96.5z"
          fill="#f1f7f8"
        />
        <path d="m44 41h125v148h-125z" fill="#fff" />
        <path d="m45 42h123v146h-123z" stroke="#054b54" strokeWidth={2} />
        <g stroke="#d3e5e7">
          <path d="m58.5 128.5h45" />
          <path d="m110.5 128.5h45" />
          <path d="m58.5 136.5h97.121" />
          <path d="m58.5 144.5h97.121" />
        </g>
        <path
          d="m106.5 118.5c13.255 0 24-10.745 24-24 0-13.2548-10.745-24-24-24-13.2548 0-24 10.7452-24 24 0 13.255 10.7452 24 24 24z"
          stroke="#e3e3e3"
        />
        <path
          d="m54.097 55.118h-.1001v4.8809h1.8331v-4c-.2141-.2567-.478-.467-.7759-.6184-.2979-.1515-.6236-.2408-.9571-.2625z"
          fill="#054b54"
        />
        <path
          d="m61.028 54.6321v.905c.2185.2799.4933.5107.8066.6777.3133.1671.6583.2667 1.0124.2923h.014v-4.8811h-1.833z"
          fill="#054b54"
        />
        <path
          d="m61.0319 57.0549c-.3154-.2183-.6026-.4749-.855-.7639l-2.52-2.8579c-.4275-.5407-.9672-.9824-1.582-1.2942s-1.2901-.4865-1.979-.5119h-.075v2.353h.075c.6187.0053 1.2225.1912 1.737.5349.3488.2295.6643.5058.938.821l2.5201 2.8582c.4276.5407.9674.9821 1.5822 1.2939s1.2899.4865 1.9788.512v-2.353c-.068 0-.135-.0001-.2-.0081-.5827-.0452-1.1425-.247-1.6201-.584z"
          fill="#f64928"
        />
        <path d="m72 52h86v9h-86z" fill="#f3f6f4" />
        <path d="m84 155h47v16h-47z" fill="#478f9a" />
        <g strokeLinejoin="round" strokeWidth={2}>
          <path
            d="m112.233 178.515-4.3 2.966-1.1-16.616 6.376 3.584 7.552 4.607-4.138 2.545 4.138 5.88-4.935 3.019z"
            fill="#fff"
            stroke="#043764"
          />
          <g stroke="#478f9a" strokeLinecap="round">
            <path d="m107 110c8.56 0 15.5-6.94 15.5-15.5 0-8.5604-6.94-15.5-15.5-15.5-8.5604 0-15.5 6.9396-15.5 15.5 0 8.56 6.9396 15.5 15.5 15.5z" />
            <path d="m96.5 105.835c.9625-1.984 2.464-3.657 4.333-4.827 1.869-1.1705 4.029-1.7912 6.234-1.7912s4.365.6207 6.234 1.7912c1.869 1.17 3.371 2.843 4.333 4.827" />
          </g>
        </g>
        <path d="m107 96c3.314 0 6-2.6863 6-6s-2.686-6-6-6-6 2.6863-6 6 2.686 6 6 6z" fill="#fff" />
        <path
          d="m107 95c2.761 0 5-2.2386 5-5s-2.239-5-5-5-5 2.2386-5 5 2.239 5 5 5z"
          stroke="#478f9a"
          strokeWidth={2}
        />
      </g>
    </g>
  </svg>
);
export default Register;
